import React from 'react';
import injectSheet from 'react-jss';
import theme, {
  cardCopy, cardTitle, expandAbsolutely, cardOverlayTitle,
} from '../../styles/theme';
import BaseCaption from '../Caption';
import { mergeTitleAndCopyAndOverlayClassNames } from '../../helpers/mergeClassNames';

const Caption = ({ classes, classNames, ...rest }) => (
  <BaseCaption
    classNames={mergeTitleAndCopyAndOverlayClassNames(classNames, classes)}
    titleTag="h3"
    {...rest}
  />
);

Caption.propTypes = BaseCaption.propTypes;
Caption.defaultProps = BaseCaption.defaultProps;

export default injectSheet({
  title: {
    ...cardTitle,
    color: ({ colourTheme }) => (colourTheme ? colourTheme.textColour : cardTitle.color),
    [theme.breakpoints.up('md')]: {
      fontSize: cardTitle.fontSize,
    },
  },
  copy: {
    ...cardCopy,
    color: ({ colourTheme }) => (colourTheme ? colourTheme.textColour : cardCopy.color),
    marginBottom: 4,
    [theme.breakpoints.up('md')]: {
      fontSize: cardCopy.fontSize,
    },
  },
  overlayTitle: {
    ...cardOverlayTitle,
    [theme.breakpoints.up('md')]: {
      marginBottom: '32px',
    },
  },
  overlayContainer: {
    ...expandAbsolutely,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    paddingLeft: '24px',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
      justifyContent: 'center',
      paddingLeft: 0,
    },
  },
})(Caption);
